// Plate orientation: CSS can't see an image's intrinsic shape, so mark a
// Photo post whose feature image is taller than wide with .is-portrait on
// .gh-reading once the dimensions are known; reading.css then drops the
// full-width plate placement and the post keeps the ordinary layout.
export default function plate() {
    const reading = document.querySelector(".gh-reading--plate");
    const img = reading && reading.querySelector(".gh-article-image img");
    if (!img) return;

    const mark = () => {
        if (img.naturalHeight >= img.naturalWidth) reading.classList.add("is-portrait");
    };

    if (img.complete && img.naturalWidth) {
        mark();
    } else {
        img.addEventListener("load", mark, { once: true });
    }
}
